import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const SimonFraserUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Simon Fraser University (SFU)"
      universityShortName="SFU"
      slug="simon-fraser-university"
      seoTitle="SFU Study Rooms | Burnaby, Surrey & Vancouver Campus Study Guide"
      seoDescription="Complete guide to study rooms at SFU. Find Bennett Library, Fraser Library, and Belzberg Library spaces. Plus free 24/7 online alternative."
      seoKeywords="sfu study rooms, simon fraser university library, bennett library, sfu burnaby study spaces, sfu vancouver library"
      canonicalUrl="/study-room/simon-fraser-university/"
      heroDescription="A comprehensive guide to study rooms at SFU across Burnaby, Surrey, and Vancouver campuses."
      libraryWebsiteUrl="https://www.lib.sfu.ca/"
      libraryWebsiteName="SFU Library"
      studySpaces={[
        {
          name: "W.A.C. Bennett Library - Group Study (Floors 2-3)",
          features: "Designated group study areas for collaborative work.",
          feedback: "Good for group projects; can be lively."
        },
        {
          name: "W.A.C. Bennett Library - Quiet Study (Floors 4, 5, 7)",
          features: "Quiet zones for focused individual work.",
          feedback: "Appreciated for clear noise designation."
        },
        {
          name: "W.A.C. Bennett Library - Silent Study (Floor 6)",
          features: "Complete silence for intensive study.",
          feedback: "Highly valued during exam periods."
        },
        {
          name: "Fraser Library (Surrey)",
          features: "Rooms 3658-3670 for groups; remainder is quiet with one silent room (3650).",
          feedback: "Good Surrey campus option with variety."
        },
        {
          name: "Belzberg Library (Vancouver)",
          features: "Mezzanine (Room 1056) and main floor (Room 1002) for groups; otherwise quiet.",
          feedback: "Great for Vancouver campus students."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Choose your floor based on your work style—<strong>group work on floors 2-3 at Bennett</strong>, <strong>solo study on floor 6 or 7</strong>. For a view of Vancouver, try the Research Commons at Harbour Centre.
          </p>
          <p className="mb-4">
            Students can reserve group rooms <strong>up to 14 days in advance</strong> for a maximum of two hours; unoccupied bookings become drop-in after 10 minutes.
          </p>
          <p>
            Always arrive early to keep your reservation—the 10-minute no-show rule means late arrivals lose their booking.
          </p>
        </>
      }
      summaryTips={[
        "Choose floor by noise level: Floors 2-3 for groups, 4-5-7 for quiet, 6 for silence.",
        "Book up to 14 days ahead: Maximum two-hour sessions for group rooms.",
        "Arrive within 10 minutes: No-show rule releases bookings to drop-in users.",
        "Try Harbour Centre: Research Commons offers views of Vancouver.",
        "Use CSW for flexibility: No 10-minute rules or two-hour limits."
      ]}
    />
  );
};

export default SimonFraserUniversity;
